import { palette } from '@shared/theme/palette';

/**
 * Список доступных цветовых тем приложения.
 * Используем `as const` для получения литеральных типов вместо enum.
 */
export const COLORS = [
  // DEFAULT
  {
    name: 'default',
    ...palette.light.primary
  },
  // PURPLE
  {
    name: 'purple',
    lighter: '#EBD6FD',
    light: '#B985F4',
    main: '#7635dc',
    dark: '#431A9E',
    darker: '#200A69',
    contrastText: '#fff'
  },
  // CYAN
  {
    name: 'cyan',
    lighter: '#D1FFFC',
    light: '#76F2FF',
    main: '#1CCAFF',
    dark: '#0E77B7',
    darker: '#053D7A',
    contrastText: palette.light.grey[800]
  },
  // BLUE
  {
    name: 'blue',
    lighter: '#CCDFFF',
    light: '#6697FF',
    main: '#0045FF',
    dark: '#0027B7',
    darker: '#00137A',
    contrastText: '#fff'
  },
  // ORANGE
  {
    name: 'orange',
    lighter: '#FEF4D4',
    light: '#FED680',
    main: '#fda92d',
    dark: '#B66816',
    darker: '#793908',
    contrastText: palette.light.grey[800]
  },
  // RED
  {
    name: 'red',
    lighter: '#FFE3D5',
    light: '#FFC1AC',
    main: '#FF3030',
    dark: '#B71833',
    darker: '#7A0930',
    contrastText: '#fff'
  }
] as const;

/**
 * Тип, представляющий доступные названия цветовых тем (замена enum).
 */
export type ColorName = (typeof COLORS)[number]['name'];

/**
 * Тип, описывающий структуру объекта цветовой темы.
 */
export type Color = (typeof COLORS)[number];

/**
 * Утилита для поиска темы по имени.
 * @param name - имя темы из ColorName
 * @returns объект темы или undefined
 */
export function getColor(name: ColorName): Color {
  const selectedColor = COLORS.find((c) => c.name === name);
  if (!selectedColor) return COLORS[0];
  return selectedColor;
}
